import experiment from 'experiment';
import type { ComponentPartName } from './componentRegistry';
import { getEditorHost } from '@wix/santa-editor-utils';

const componentPartsAllowedMap = new Map<string, boolean>([
  /**
   * Work around to get settings panel from editor-elements-library
   * Should remove this when finish migrating panels
   * Jira Ticket: https://jira.wixpress.com/browse/ECL-5480
   */
  [
    'wysiwyg.viewer.components.Grid-settingsPanel',
    experiment.isOpen('se_gridPanelsMigration'),
  ],
  [
    'wysiwyg.viewer.components.Grid-gfpp',
    experiment.isOpen('se_gridPanelsMigration'),
  ],
  [
    'wysiwyg.viewer.components.gridColumnManagerPanel',
    experiment.isOpen('se_gridPanelsMigration'),
  ],
  [
    'wixui.VideoPlayer-settingsPanel',
    experiment.isOpen('se_SingleVideoPlayer_panels_migration'),
  ],
  [
    'wysiwyg.viewer.components.Repeater-layoutPanel',
    experiment.isOpen('se_repeaterPanelsMigration'),
  ],
  [
    'wysiwyg.viewer.components.Repeater-managePanel',
    experiment.isOpen('se_repeaterPanelsMigration'),
  ],
  [
    'wysiwyg.viewer.components.Repeater-gfpp',
    experiment.isOpen('se_repeaterPanelsMigration'),
  ],
  [
    'wysiwyg.viewer.components.Repeater-metadata',
    experiment.isOpen('se_repeaterPanelsMigration'),
  ],
  [
    'wysiwyg.viewer.components.StripContainerSlideShow-layoutPanel',
    experiment.isOpen('se_stripContainerSlideShowLayoutPanelMigration'),
  ],
  [
    'wysiwyg.viewer.components.BoxSlideShow-layoutPanel',
    experiment.isOpen('se_boxSlideShowLayoutPanelMigration'),
  ],
  [
    'wysiwyg.viewer.components.LoginSocialBar-gfpp',
    experiment.isOpen('se_useLoginSocialBarSettingsPanelFromEditorElements'),
  ],
  [
    'wysiwyg.viewer.components.LoginSocialBar-layoutPanel',
    experiment.isOpen('se_useLoginSocialBarSettingsPanelFromEditorElements'),
  ],
  [
    'wysiwyg.viewer.components.LoginSocialBar-settingsPanel',
    experiment.isOpen('se_useLoginSocialBarSettingsPanelFromEditorElements'),
  ],
  [
    'wysiwyg.viewer.components.inputs.Checkbox-metadata',
    experiment.isOpen('se_checkboxMigrationSantaToEE'),
  ],
  [
    'wysiwyg.viewer.components.inputs.Checkbox-gfpp',
    experiment.isOpen('se_checkboxMigrationSantaToEE'),
  ],
  [
    'wysiwyg.viewer.components.inputs.Checkbox-layoutPanel',
    experiment.isOpen('se_checkboxMigrationSantaToEE'),
  ],
  [
    'wysiwyg.viewer.components.inputs.Checkbox-settingsPanel',
    experiment.isOpen('se_checkboxMigrationSantaToEE'),
  ],
]);

export const isNewStaticsEnabled = () =>
  experiment.isOpen('specs.editor-elements.useNewStatics');

export const isMobileLibraryEnabled = () =>
  getEditorHost() === 'MOBILE_APP_BUILDER';

export function isComponentPartAllowed<TPartName extends ComponentPartName>(
  componentType: string,
  componentPartName: TPartName | string,
): componentPartName is TPartName {
  if (componentPartsAllowedMap.has(`${componentType}-${componentPartName}`)) {
    return componentPartsAllowedMap.get(
      `${componentType}-${componentPartName}`,
    );
  }

  return true;
}
